// Returns true if any unsaved-changes Stimulus controller on the page
// currently has dirty input. Shared by mode_toggle and group controllers.
export function hasUnsavedChangesOnPage(application) {
  const forms = document.querySelectorAll('[data-unsaved-changes-target="form"]')
  for (const form of forms) {
    const ctrl = application.getControllerForElementAndIdentifier(form, "unsaved-changes")
    if (ctrl && ctrl.isDirty) return true
  }
  return false
}

// Marks every unsaved-changes controller on the page as clean. Call this when
// the caller has already shown its own confirmation and the user agreed to
// discard pending edits, so the global beforeunload/turbo:before-visit guard
// does not re-prompt.
export function clearUnsavedChangesOnPage(application) {
  const forms = document.querySelectorAll('[data-unsaved-changes-target="form"]')
  for (const form of forms) {
    const ctrl = application.getControllerForElementAndIdentifier(form, "unsaved-changes")
    ctrl?.dirtyScopes?.clear()
  }
}
